const Footer = () => {
  return null;
};
export default Footer;
